export const useCalendarStyles = () => {
  return {
    progress: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: 'calc(100vh - 108px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
      zIndex: 10,
    }
  }
}